module.exports = __webpack_public_path__ + "static/media/BearBasketball.fb55dac6.jpg";